export default __webpack_public_path__ + "app/images/theme-images/dark/submit-btn/icon-20-send@2x.webp";